import { SimpleError } from "@simonbackx/simple-errors";
class StringDecoder {
    decode(data) {
        if (typeof data.value == "string") {
            return data.value;
        }
        throw new SimpleError({
            code: "invalid_field",
            message: `Expected a string at ${data.currentField}`,
            field: data.currentField
        });
    }
}
// We export an instance to prevent creating a new instance every time we need to decode a number
export default new StringDecoder();
//# sourceMappingURL=StringDecoder.js.map